import { AuthenticationType } from 'dy-frontend-http-repository/lib/modules/Auth/enums';

const authenticationPriority: { [key in AuthenticationType]: number } = {
    [AuthenticationType.GOOGLE]: 0,
    [AuthenticationType.EMAIL_PASSWORD]: 1,
};

export default authenticationPriority;
